import { LoginForm } from "./Form";
import logo from "../../../public/images/logo.png";
import logoColor from "../../../public/images/logo-color.png";
import logoFavicon from "../../../public/images/logo-favicon.png";

export default function Login() {
  return (
    <div className="h-screen flex">
      <div className="flex flex-col items-center justify-center gap-6 md:order-2 flex-1 pr-2 pl-2">
        <div className="flex flex-col items-center">
          <div className="flex md:hidden justify-center items-center flex-1 h-full bg-zinc-200/30 dark:bg-zinc-900/50">
            <div className="w-44 h-auto bg-zinc-200 rounded-lg overflow-hidden">
              {/* <img src={logo} alt="Image" className="w-full h-auto" /> */}
            </div>
          </div>
          <img
            src={logoColor}
            alt="Image"
            className="size-[12rem] rounded object-contain sm:hidden"
          />
          <img
            src={logoFavicon}
            alt="Image"
            className="size-[8rem] rounded object-contain hidden sm:block"
          />
          <h1 className="mt-4 text-3xl font-bold">Bem-vindo</h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Faça login para continuar
          </p>
        </div>
        <LoginForm />
      </div>
      <div className="hidden md:flex justify-center items-center flex-1 h-full bg-primary">
        <div className="aspect-square w-60 h-auto  rounded-lg overflow-hidden">
          <img
            src={logo}
            alt="Image"
            className="aspect-square object-contain w-full"
          />
        </div>
      </div>
    </div>
  );
}
